import {connect} from 'react-redux';
import TurboCashView from '../../../components/views/mx/turboCash/TurboCashView';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import {withRouter} from 'react-router';
import * as WizardActions from '../../../actions/WizardActions';
import * as FileTypeConstants from '../../../../common/constants/FileTypeConstants';
import {MODAL_TYPE} from '../../../constants/ModalConstants';
import * as ModalActions from '../../../actions/ModalActions';
import {BankTarget} from '../../../types/mx/types';

const mapStateToProps = (state, {match, landing, app}) => {
    const personalDataStepViewFieldErrorState = state.turboCash.ui.personalDataStepView.fieldErrors;
    const employmentDataViewFieldErrorState = state.turboCash.ui.workDataStepView.fieldErrors;
    const otherReferences = state.turboCash.loanApplication.otherReferences.references;
    const files = state.turboCash.loanApplication.files;

    return {
        app,
        landing,
        otherReferences,
        ifeFrontFiles: files.identification.ifeFrontFiles,
        ifeBackFiles: files.identification.ifeBackFiles,
        carLicenceFrontFiles: files.carLicence.carLicenceFrontFiles,
        carLicenceBackFiles: files.carLicence.carLicenceBackFiles,
        homeFiles: files.home.homeFiles,
        otherMonth1Files: files.other.otherMonth1Files,
        otherMonth2Files: files.other.otherMonth2Files,
        otherMonth3Files: files.other.otherMonth3Files,
        loanApplicationToken: match.params.token,
        civilStatusFieldError: personalDataStepViewFieldErrorState.civilStatusFieldError,
        regimeFieldError: personalDataStepViewFieldErrorState.regimeFieldError,
        rolHomeFieldError: personalDataStepViewFieldErrorState.rolHomeFieldError,
        studiesFieldError: personalDataStepViewFieldErrorState.studiesFieldError,
        houseTypeFieldError: personalDataStepViewFieldErrorState.houseTypeFieldError,
        amountDependentsFieldError: personalDataStepViewFieldErrorState.amountDependentsFieldError,
        cURPFieldError: personalDataStepViewFieldErrorState.cURPFieldError,
        rootFieldError: personalDataStepViewFieldErrorState.rootFieldError,
        lapseFieldError: personalDataStepViewFieldErrorState.lapseFieldError,
        workplaceNameFieldError: employmentDataViewFieldErrorState.workplaceNameFieldError,
        positionFieldError: employmentDataViewFieldErrorState.positionFieldError,
        workingSinceFieldError: employmentDataViewFieldErrorState.workingSinceFieldError,
        employmentRotationFieldError: employmentDataViewFieldErrorState.employmentRotationFieldError,
        addressFieldError: employmentDataViewFieldErrorState.addressFieldError,
        extNumberFieldError: employmentDataViewFieldErrorState.extNumberFieldError,
        streetBetweenFieldError: employmentDataViewFieldErrorState.streetBetweenFieldError,
        workplacePhoneFieldError: employmentDataViewFieldErrorState.workplacePhoneFieldError,
        workplacePhoneExtError: employmentDataViewFieldErrorState.workplacePhoneExtError,
        monthlyIncomesFieldError: employmentDataViewFieldErrorState.monthlyIncomesFieldError,
        postalCodeFieldError: employmentDataViewFieldErrorState.postalCodeFieldError,
        stateFieldError: employmentDataViewFieldErrorState.stateFieldError,
        cityFieldError: employmentDataViewFieldErrorState.cityFieldError,
        municipalityFieldError: employmentDataViewFieldErrorState.municipalityFieldError,
        selectedColonyFieldError: employmentDataViewFieldErrorState.selectedColonyFieldError,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onSaveChanges: (isInterval: boolean = false) => {
            dispatch(WizardMXActions.SAVE_TURBO_CASH_DATA_MX_ACTION.action(isInterval));
        },
        onDropIdentificationFiles: (files, type, section, error) => {
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDropHomeFiles: (files, type, section, error) => {
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDropOtherFiles: (files, type, section, error) => {
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDropCarLicenceFiles: (files, type, section, error) => {
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDeleteIdentificationFile: (id) => {
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.IDENTIFICATION_TYPE, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDeleteHomeFile: (id) => {
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.HOME_TYPE, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDeleteOtherFile: (id) => {
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.OTHER_TYPE, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDeleteCarLicenceFile: (id) => {
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.IDENTIFICATION_TYPE, BankTarget.TURBO_CASH_STATE
            ));
        },
        onClickThumbnail: (item) => {
            const content = {
                type: MODAL_TYPE.SHOW_FILE_IMG_VIEW,
                data: item
            };
            const options = {
                closeOnOverlayClick: true,
                size: 'small'
            };
            dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(null, content, null, options));
        },
        getLoanApplication: token => () =>
            dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_TC_ACTION.action(token))
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        getLoanApplication: dispatchProps.getLoanApplication(stateProps.loanApplicationToken)
    };
};

const TurboCashContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(TurboCashView));

export default TurboCashContainer;